export class Pagination {
  size: number;
  page: number;

  constructor(size: number, page: number) {
    this.page = page;
    this.size = size;
  }

  generarUrl() {
    let url: string;
    url = '?size=' + this.size + '&page=' + this.page;
    return url;
  }
}
